import { Fragment, ReactNode } from 'react';
import { getLastIndex } from 'utils/array';

interface MultiLineTextProps {
  text: string;

  purgeEmptyLines?: boolean;

  renderLine: (
    t: string,
    ops: { index: number; isLast: boolean; isFirst: boolean; total: number },
  ) => ReactNode;
}

/**
 * Use this to automatically generate multi lines
 */
export function MultiLineText({ text, renderLine, purgeEmptyLines }: MultiLineTextProps) {
  const lines = text.split('\n').filter((line) => (purgeEmptyLines ? !!line.trim() : true));

  return (
    <>
      {lines.map((line, index) => (
        <Fragment key={line}>
          {renderLine(line, {
            index,
            isFirst: index === 0,
            isLast: index === getLastIndex(lines),
            total: lines.length,
          })}
        </Fragment>
      ))}
    </>
  );
}
